import React, { Component } from 'react';
import GraficoBarra from '../../charts/GraficoBarra';
import SimplePopover from '../../SimplePopover';
import PopupNotas from './PopupNotas';

class ComponenteCurricular extends Component {

    getMediasDisciplina() {
        return this.props.mediasDisciplina || [];
    }

    render() {
        return (<div>
            {this.getMediasDisciplina().map(disciplina => {
                return <div key={"'disciplina_"+disciplina.idDiscipline} className="edb-row edb-margin-small-top">
                    <div className="edb-col m4 l2 edb-right-align edb-left-align-mobile edb-padding-right">{disciplina.txDiscipline}
                        {!this.props.grade && disciplina.pcCorrectStudent < disciplina.pcCorrectSchool && <SimplePopover content="Sua média é menor do que a média da sua escola">
                            <i className="fas fa-exclamation-triangle adap-text-red edb-padding-small-left "></i>
                        </SimplePopover>}
                    </div>
                    <div className="edb-col m8 l10">
                        {!this.props.grade && <SimplePopover block={true} content={<PopupNotas titulo={disciplina.txDiscipline} meuDesempenho={disciplina.pcCorrectStudent} minhaEscola={disciplina.pcCorrectSchool} escolaReferencia={0}/>}>
                            <GraficoBarra className="" percentage={disciplina.pcCorrectStudent} indicatorPercentage={disciplina.pcCorrectSchool} starPercentage={0} />
                        </SimplePopover>}
                        {this.props.grade && <SimplePopover block={true} content={<PopupNotas titulo={disciplina.txDiscipline} grade={this.props.grade} meuDesempenho={disciplina.pcCorrectSchool} minhaEscola={0} escolaReferencia={0}/>}>
                            <GraficoBarra className="" percentage={disciplina.pcCorrectSchool} indicatorPercentage={0} starPercentage={0} />
                        </SimplePopover>}
                    </div>
                </div>
            })}
        </div>);
    }
}

export default ComponenteCurricular;